import React, { useState, useEffect } from 'react';
import Button from './ui/Button';
import { t, getCurrentLanguage } from '../utils/i18n';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookie-consent');
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <div className="flex-1">
            <p className="text-sm text-gray-600">
              {t('cookie_consent.message')}{' '}
              <a 
                href={`/documents/${getCurrentLanguage()}/privacy_policy.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-500 hover:underline ml-1"
              >
                {t('cookie_consent.privacy_policy_link')}
              </a>.
            </p>
          </div>
          <div className="flex space-x-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
            >
              {t('cookie_consent.decline')}
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
            >
              {t('cookie_consent.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
